import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import {
  CurrencyInput,
  type CurrencyInputProps,
} from "../input/input-currency";

export type FormCurrencyFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  inputClasses?: string;
  description?: string;
  className?: string;
} & CurrencyInputProps;

export const FormCurrencyField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  inputClasses,
  ...props
}: FormCurrencyFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <CurrencyInput
          {...props}
          {...field}
          aria-label={label}
          className={inputClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormCurrencyField.displayName = "FormCurrencyField";
